var map = {
	"./_academy.png": 65931,
	"./_academy.webp": 80272,
	"./_analytics.png": 24249,
	"./_analytics.webp": 4306,
	"./_chemical.png": 27657,
	"./_chemical.webp": 95490,
	"./_community.png": 70610,
	"./_community.webp": 94563,
	"./_discovery.png": 85499,
	"./_discovery.webp": 99520,
	"./_eureka.png": 17784,
	"./_eureka.webp": 47141,
	"./_help_center.png": 52878,
	"./_help_center.webp": 92503,
	"./_inno.png": 17681,
	"./_inno.webp": 18730,
	"./_innocloud.png": 23618,
	"./_innocloud.webp": 98707,
	"./_insights.png": 26026,
	"./_insights.webp": 72155,
	"./_lifescience.png": 91745,
	"./_lifescience.webp": 69946,
	"./_ls360.png": 43037,
	"./_ls360.webp": 11438,
	"./_public_pages.png": 23443,
	"./_public_pages.webp": 18392,
	"./_synapse.png": 64100,
	"./_synapse.webp": 59033,
	"./_tffi.png": 98328,
	"./_tffi.webp": 48037,
	"./_workspace.png": 70798,
	"./_workspace.webp": 66071,
	"./_yunchuang.png": 70103,
	"./_yunchuang.webp": 54740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38373;